import KTileItem from './KTileItem';
import React, { useRef } from 'react';
import classes from './AssetCont.module.scss';
import { KTileDTO } from '@envclient/envengine/src/envs/koenigsburg/KTile';

interface AssetContProps {
  assets: KTileDTO[];
  onClick: (tileId: number, startStyle?: { left: number; top: number }) => void;
  canvasRef: React.RefObject<HTMLDivElement>;
  zoom: number;
}

const OFFSET = 260;

const AssetCont = (props: AssetContProps) => {
  const { canvasRef, zoom } = props;
  const tileRefs = useRef<Map<number, HTMLDivElement>>(new Map());

  return (
    <div className={classes.assetCont}>
      {props.assets.map((tile, index) => {
        if (!tile) return null;
        const divStyle = {
          top: 0 + 'px',
          left: index * OFFSET + 'px'
        };
        return (
          <div
            className={classes.tileBg}
            key={tile.id}
            style={divStyle}
            ref={(el) => {
              if (el) tileRefs.current.set(tile.id, el);
              else tileRefs.current.delete(tile.id);
            }}
            onClick={() => {
              let startStyle: { left: number; top: number } | undefined;
              const tileEl = tileRefs.current.get(tile.id);
              if (tileEl && canvasRef.current) {
                const tileRect = tileEl.getBoundingClientRect();
                const canvasRect = canvasRef.current.getBoundingClientRect();
                startStyle = {
                  left: (tileRect.left - canvasRect.left) / zoom,
                  top: (tileRect.top - canvasRect.top) / zoom
                };
              }
              props.onClick(tile.id, startStyle);
            }}>
            <KTileItem active={true} tile={tile} />
          </div>
        );
      })}
    </div>
  );
};

export default AssetCont;
